import React from 'react';
type Coach = {
  title: string;
  body: string;
  tokens: {
    cls: string;
    letter?: string;
  }[];
};
const coaches: Coach[] = [{
  title: 'The coach who inherited an event group',
  body: 'A distance runner now coaching sprints. The throws coach quit and the throwers are yours. Every card tells you the setup, the reps, the rest, the cues and the most common mistake, and Track Talk explains the words.',
  tokens: [{
    cls: 'bg-hl text-hl-ink',
    letter: 'C'
  }, {
    cls: 'bg-infield'
  }, {
    cls: 'bg-infield'
  }]
}, {
  title: 'The coach with 40 athletes and one whistle',
  body: 'Five event groups, a couple of assistants or none. Low-risk groups work from their card while you stand where the risk is, and the large-group circuit keeps 40 athletes working at once.',
  tokens: [{
    cls: 'bg-hl text-hl-ink',
    letter: 'C'
  }, {
    cls: 'bg-clay'
  }, {
    cls: 'bg-amber'
  }, {
    cls: 'bg-infield'
  }, {
    cls: 'bg-lane'
  }]
}, {
  title: 'The first-year or volunteer coach',
  body: 'Middle school, a youth club or your first season as head coach. Day One Ready plans your first two weeks day by day, and the Level Dial fits every practice to Youth, Middle School or High School.',
  tokens: [{
    cls: 'bg-hl text-hl-ink',
    letter: 'C'
  }, {
    cls: 'bg-[#8A93A8] text-white',
    letter: 'H'
  }]
}];

/** "Who it's for": shown in place of reviews until real ones come in. */
export function Audience() {
  return <section aria-labelledby="audience-heading" className="w-full bg-navy text-chalk" data-id="element-38" data-mp="1uads6v5djo8i">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20" data-id="element-39" data-mp="1z1vtxlf81suj">
        <div className="text-center" data-id="element-40" data-mp="1z2fbh10ymf81">
          <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-hl" data-id="element-41" data-mp="240gtrjqkaaig">Who it&apos;s for</p>
          <h2 id="audience-heading" className="mt-3 font-display text-3xl text-chalk sm:text-5xl" data-id="element-42" data-mp="282tzi85b68f8">
            Built for the coach who got handed the event group
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm text-chalk/70 sm:text-base" data-id="element-43" data-mp="cz5efns6d35f">
            Head coaches, assistants and first-year coaches running school and
            club track, with more events than coaches and less time than
            they&apos;d like.
          </p>
        </div>

        <div className="mt-9 grid gap-4 md:grid-cols-3" data-id="element-44" data-mp="mqte2byvxqhz">
          {coaches.map(coach => <article key={coach.title} className="flex flex-col rounded-2xl border border-navy-line bg-navy-card p-5 shadow-card sm:p-6" data-id="element-45" data-mp="hwfd7u1ger5x">
              <ul className="flex -space-x-1.5" aria-hidden="true" data-id="element-46" data-mp="rouv6rcr3fqt">
                {coach.tokens.map((t, i) => <li key={i} data-id="element-47" data-mp="15mjfny2wokvc" data-mpi={i}>
                    <span className={`flex h-9 w-9 items-center justify-center rounded-full border-2 border-navy-card font-display text-sm font-bold shadow-[inset_0_-3px_6px_rgba(0,0,0,0.25)] ${t.cls}`} data-id="element-48" data-mp="15lqgbi6a0xn8">
                      {t.letter}
                    </span>
                  </li>)}
              </ul>
              <h3 className="mt-4 font-display text-xl font-bold uppercase leading-tight text-chalk" data-id="element-49" data-mp="1hz3qfcxgg84x">{coach.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-chalk/75" data-id="element-50" data-mp="1mwn8yp16r72o">{coach.body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}